import React, {ReactNode, useContext, useEffect, useRef} from "react";
import {createUseStyles} from "react-jss";
import clsx from "clsx";
import {Virtuoso} from "react-virtuoso";
import {InputType} from "../../state/questions";
import {Letters, TriviaStatus} from "../../state/state";
import {EngageAppContext} from "../../App";
import {useDimensionObserver} from "engage-client/hooks/useDimensionObserver";
import Button from "engage-client/components/Button";
import QuestionUpload from "./QuestionUpload";
import Modal from "engage-client/components/Modal";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";

const useStyles = createUseStyles({
	tabContainer: {
		flex:1,
		display:"flex",
		flexDirection: "column",
	},
	button: {
		margin: 8
	},
	questionContainer: {
		flex:1,
	},
	question: {
		backgroundColor: "white",
		boxShadow: "0px 3px 6px #00000029",
		width: "calc(100% - 10px)",
		padding: 10,
		margin: [10,0]
	},
	answers: {
		marginTop: 10,
	},
	questionCurrent: {
		border: "solid 1px #002C4655",
		backgroundColor: "#FFFFDF",
	},
	correct: {
		fontWeight: "bold",
	},
	modalContent: {
		borderRadius: 5,
		padding: 0,
		boxShadow: "0 4px 8px 0 rgb(255 255 255 / 20%), 0 6px 20px 0 rgb(255 255 255 / 19%)"
	}
});

export default function HostQuestions() {

	function renderRow(index:number) {
		const question = appState.host!.trivia[index];
		const current = index === appState.common.currentIndex;
		let answers:ReactNode[] = [];
		if(question.inputType === InputType.MC) {
			for(let i = 0; i < question.options.length; i++) {
				const correct = question.correctIndex === i;
				answers[i] = <div key={`answer${i}`} className={clsx(correct && !question.poll && classes.correct)}>{Letters[i]}. {question.options[i]}</div>;
			}
		} else if(question.inputType === InputType.Phrase) {
			answers[0] = <div key="answer">{question.phrase}</div>;
		}

		return (
			<DisplayText variant={TextVariant.s16reg} key={index} color="primary" lineHeight={"1.2rem"} limitScaling={true}>
				<div className={clsx(classes.question, current && classes.questionCurrent)}>
					<div>{index+1}. {question.prompt}</div>
					<div className={classes.answers}>
						{answers}
					</div>
				</div>
			</DisplayText>
		);
	}

	const {appState} = useContext(EngageAppContext.current);
	const classes = useStyles();
	const [uploadOpen, setUploadOpen] = React.useState(false);
	const containerRef = useRef(null);
	const {height:containerHeight} = useDimensionObserver(containerRef);
	const listRef = useRef<any>(null);

	function openTriviaUpload() {
		if(appState.common.state === TriviaStatus.Pending) {
			setUploadOpen(true);
		} else {
			alert("Trivia State must be pending to change questions. Use RESET! before changing questions.");
		}
	}

	function closeTriviaUpload() {
		setUploadOpen(false);
	}

	useEffect(() => {
		if(listRef.current) {
			const scrollItem = Math.min(appState.common.currentIndex, appState.common.totalQuestions-1);
			listRef.current.scrollToIndex(scrollItem);
		}
	}, [appState.common.currentIndex, appState.common.totalQuestions, containerHeight]);

	return (
		<div className={classes.tabContainer}>
			<div className={classes.questionContainer} ref={containerRef}>
				{
					appState.host && containerHeight ? (
						<Virtuoso style={{width:"100%", height: containerHeight}}
								  totalCount={appState.host?.trivia.length}
								  item={renderRow}
								  ref={listRef}/>
					) : undefined
				}
			</div>
			<Button onClick={openTriviaUpload} className={classes.button}>Upload New Questions As CSV</Button>

			<Modal
				isVisible={uploadOpen}
				onBackdropClick={closeTriviaUpload}
				contentClassname={classes.modalContent}
			>
				<QuestionUpload closeHandler={closeTriviaUpload}/>
			</Modal>
		</div>
	);

};